import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient}from '@angular/common/http';
import { Csp5090Class } from '../../CSPClass/CSP5090/csp5090-class';
import { environment } from '../../../../../../../src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class Csp5090Service {
     baseUrl: string=  environment.baseUrlCsp + 'CSP5090/';
  constructor(private http:HttpClient) { }

   Deposits(Csp5090Class:Csp5090Class):Observable<any>
                   {                  
                      return this.http.post<any>(this.baseUrl+'Deposits',Csp5090Class);
                  }
  
}
